import React from 'react';
import { observer } from 'mobx-react-lite';
import Badge from '../badge';
const InvalidBadge = function InvalidBadge(props) {
    const { children, isInvalid, prefixCls } = props;
    const invalid = isInvalid();
    return invalid ? (React.createElement(Badge, { className: `${prefixCls}-invalid-badge`, count: React.createElement("i", { className: `${prefixCls}-invalid-badge-content` }) }, children)) : React.createElement(React.Fragment, null, children);
};
InvalidBadge.displayName = 'InvalidBadge';
export default observer(InvalidBadge);
